import { render, staticRenderFns } from "./VR.vue?vue&type=template&id=6df2915c&scoped=true&"
import script from "./VR.vue?vue&type=script&lang=ts&"
export * from "./VR.vue?vue&type=script&lang=ts&"
import style0 from "./VR.vue?vue&type=style&index=0&id=6df2915c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df2915c",
  null
  
)

export default component.exports